import React from 'react'
import { gql, useMutation } from 'urql'
import FormDialog from '../dialogs/FormDialog'
import { nonFieldErrors } from '../util/errutil'

const mutation = gql`
  mutation ($id: ID!) {
    deleteServiceNotificationRule(id: $id)
  }
`
export default function ServiceNotificationRuleDeleteDialog(props: {
  ruleID: string
  onClose: () => void
}): JSX.Element {
  const { ruleID, ...rest } = props

  const [{ fetching, error }, deleteNotification] = useMutation(mutation)

  return (
    <FormDialog
      title='Are you sure?'
      confirm
      loading={fetching}
      errors={nonFieldErrors(error)}
      subTitle='This will delete the service notification rule.'
      onSubmit={() =>
        deleteNotification(
          { id: ruleID },
          {
            additionalTypenames: ['ServiceNotificationRule', 'Service'],
          },
        ).then((result) => {
          if (!result.error) props.onClose()
        })
      }
      {...rest}
    />
  )
}
